import clsx from "clsx"
import { useNavigate } from "react-router-dom"
import { FC, MouseEventHandler, useMemo } from "react"
import useFromUrl from "hooks/useFromUrl"
import { Button } from "ui/@button"
import { arrowGoBackIcon } from "assets/icons"
import { ButtonRingProps } from "../button-ring"
import "./index.scss"

interface BackButtonProps extends ButtonRingProps {
  toHome?: boolean
  onBack?: () => void
  link?: string | null
}

export const ButtonBack: FC<BackButtonProps> = ({
  toHome = false,
  onBack,
  link,

  icon,

  className,
  onClick,
  ...props
}) => {
  const navigate = useNavigate()
  const { from } = useFromUrl()

  const target = useMemo(() => (from ? from : link), [link, from])

  const handleBack: MouseEventHandler<HTMLButtonElement> = (e) => {
    if (toHome) {
      navigate("/")
      return
    }

    if (link && target) {
      navigate(target)
      return
    }

    if (onClick) {
      onClick(e)
      return
    }

    if (onBack) {
      onBack()
      return
    }

    navigate(-1)
  }

  return (
    <Button.Ring
      id="back-button"
      className={clsx(`back-button`, className)}
      triangleTopPosLeft="40%"
      triangleBottomPosLeft="none"
      onClick={handleBack}
      {...props}
      icon={icon || arrowGoBackIcon}
    />
  )
}
